import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function SettingsRow({
  to,
  onClick,
  icon,
  label,
  detail,
  chevron = true,
}: {
  to?: string;
  onClick?: () => void;
  icon?: ReactNode;
  label: string;
  detail?: string;
  chevron?: boolean;
}) {
  const inner = (
    <>
      {icon ? <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/[0.06] text-accent">{icon}</span> : null}
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-semibold text-[var(--text-primary)]">{label}</div>
        {detail ? <div className="truncate text-xs text-[var(--text-muted)]">{detail}</div> : null}
      </div>
      {chevron ? <span className="shrink-0 text-sm text-[var(--text-muted)]">›</span> : null}
    </>
  );

  const className =
    'btn-press flex w-full items-center gap-3 rounded-2xl border border-white/[0.08] bg-white/[0.04] px-4 py-3.5 text-left transition-colors hover:bg-white/[0.07]';

  if (to) {
    return (
      <Link to={to} className={className}>
        {inner}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {inner}
    </button>
  );
}
